import React, { useRef, useState } from 'react'
import styled from 'styled-components';
import { Card, CardContent, Typography, Grid, Box, Avatar, Container, Paper, Button, CircularProgress } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { authSuccess } from '../../redux/userRelated/userSlice';

const StudentProfile = () => {
  const { currentUser, response, error } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  if (response) { console.log(response) }
  else if (error) { console.log(error) }

  const sclassName = currentUser.sclassName
  const studentSchool = currentUser.school

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploading(true);
      const reader = new FileReader();
      reader.onloadend = async () => {
        const base64String = reader.result;
        try {
          const result = await axios.put(`${process.env.REACT_APP_BASE_URL}/Student/${currentUser._id}`, 
            { profilePicture: base64String }, 
            { headers: { 'Content-Type': 'application/json' } }
          );
          
          if (result.data) {
             // Combine old user state with new profile picture to keep populated fields
             const updatedUser = { ...currentUser, profilePicture: result.data.profilePicture };
             dispatch(authSuccess(updatedUser));
          }
        } catch (error) {
          console.error("Error uploading image:", error);
        } finally {
          setUploading(false);
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const hasProfilePic = currentUser?.profilePicture && currentUser.profilePicture.length > 10;

  return (
    <>
      <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
        <ProfileHeaderCard elevation={0}>
            <CoverPhoto>
                {/* Optional: Add a pattern or subtle image here */}
            </CoverPhoto>
            <AvatarContainer>
                <Avatar 
                    src={hasProfilePic ? currentUser.profilePicture : undefined}
                    alt="Student Avatar" 
                    sx={{ 
                        width: 140, 
                        height: 140, 
                        fontSize: '4rem', 
                        border: '4px solid #ffffff',
                        boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
                        bgcolor: '#1976d2'
                    }}
                >
                  {!hasProfilePic && String(currentUser.name).charAt(0)}
                </Avatar>
                
                <input 
                    type="file" 
                    accept="image/*" 
                    hidden 
                    ref={fileInputRef} 
                    onChange={handleImageUpload} 
                />
                
                <UploadButton 
                    variant="contained" 
                    onClick={() => fileInputRef.current.click()}
                    disabled={uploading}
                >
                  {uploading ? <CircularProgress size={20} color="inherit" /> : "Change Photo"}
                </UploadButton>
            </AvatarContainer>

            <Box textAlign="center" mt={8} pb={4} px={2}>
                <Typography variant="h4" fontWeight="800" color="#1e293b" gutterBottom>
                  {currentUser.name}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary" fontWeight="500" mb={2}>
                  Roll No: <span style={{ color: '#3b82f6' }}>{currentUser.rollNum}</span> • {sclassName.sclassName}
                </Typography>
                
                <InfoBadge>
                    {studentSchool.schoolName}
                </InfoBadge>
            </Box>
        </ProfileHeaderCard>

        <Grid container spacing={3} mt={1}>
            <Grid item xs={12} md={6}>
                <InfoCard elevation={0}>
                    <CardContent sx={{ p: 3 }}>
                        <Typography variant="h6" fontWeight="700" color="#0f172a" mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            Personal Details
                        </Typography>
                        <DetailRow>
                            <DetailLabel>Date of Birth</DetailLabel>
                            <DetailValue>January 1, 2000</DetailValue>
                        </DetailRow>
                        <DetailRow>
                            <DetailLabel>Gender</DetailLabel>
                            <DetailValue>Male</DetailValue>
                        </DetailRow>
                        <DetailRow>
                            <DetailLabel>Blood Group</DetailLabel>
                            <DetailValue>O+</DetailValue>
                        </DetailRow>
                    </CardContent>
                </InfoCard>
            </Grid>
            <Grid item xs={12} md={6}>
                <InfoCard elevation={0}>
                    <CardContent sx={{ p: 3 }}>
                        <Typography variant="h6" fontWeight="700" color="#0f172a" mb={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            Contact Information
                        </Typography>
                        <DetailRow>
                            <DetailLabel>Email</DetailLabel>
                            <DetailValue>{currentUser.name.split(" ")[0].toLowerCase()}@iitp.ac.in</DetailValue>
                        </DetailRow>
                        <DetailRow>
                            <DetailLabel>Phone</DetailLabel>
                            <DetailValue>+91 98765 43210</DetailValue>
                        </DetailRow>
                        <DetailRow>
                            <DetailLabel>Address</DetailLabel>
                            <DetailValue>IIT Patna Campus, Bihta, Bihar</DetailValue>
                        </DetailRow>
                    </CardContent>
                </InfoCard>
            </Grid>
        </Grid>
      </Container>
    </>
  )
}

export default StudentProfile

const ProfileHeaderCard = styled(Paper)`
  position: relative;
  border-radius: 24px !important;
  overflow: visible;
  background: #ffffff;
  box-shadow: 0 10px 40px -10px rgba(0,0,0,0.08) !important;
  margin-bottom: 32px;
`;

const CoverPhoto = styled(Box)`
  height: 200px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  background: linear-gradient(120deg, #e0c3fc 0%, #8ec5fc 100%);
`;

const AvatarContainer = styled(Box)`
  position: absolute;
  top: 130px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

const UploadButton = styled(Button)`
  background: rgba(255, 255, 255, 0.9) !important;
  color: #1e293b !important;
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 20px !important;
  padding: 6px 16px !important;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important;
  &:hover {
      background: #ffffff !important;
      box-shadow: 0 6px 16px rgba(0,0,0,0.1) !important;
  }
`;

const InfoBadge = styled(Box)`
  display: inline-block;
  background: #f1f5f9;
  color: #475569;
  padding: 6px 16px;
  border-radius: 100px;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: 0.5px;
`;

const InfoCard = styled(Card)`
  border-radius: 20px !important;
  background: #ffffff;
  box-shadow: 0 10px 40px -10px rgba(0,0,0,0.05) !important;
  height: 100%;
`;

const DetailRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #f1f5f9;
  &:last-child {
      border-bottom: none;
      margin-bottom: 0;
      padding-bottom: 0;
  }
`;

const DetailLabel = styled(Typography)`
  color: #64748b;
  font-size: 0.9rem !important;
  font-weight: 500 !important;
`;

const DetailValue = styled(Typography)`
  color: #0f172a;
  font-size: 0.95rem !important;
  font-weight: 600 !important;
  text-align: right;
`;